import Head from 'next/head'

import { LS_APP_DOMAIN } from 'config/constants'

const MetaTags = ({ resolvedUrl, keyword }) => {
  const pathName = resolvedUrl.split('?')[0]

  const title = `【${keyword.name}】相關文章、知識蒐集－信義居家`

  const breadcrumbData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首頁',
        item: 'https://livinglife.com.tw',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: '找好文',
        item: 'https://livinglife.com.tw/article',
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: title,
        item: LS_APP_DOMAIN + pathName,
      },
    ],
  }

  return (
    <Head>
      <title>{title}</title>

      <link
        key="canonical"
        rel="canonical"
        href={`${LS_APP_DOMAIN + pathName}`}
      />

      {/* For Google */}
      <meta key="title" name="title" content={title} />
      <meta
        key="description"
        name="description"
        content={`整理各種${keyword.name}相關介紹文章、知識/常識蒐集，讓你能一覽所有${keyword.name}相關文章/資訊、信義居家為您注意的居家生活大小事`}
      />

      {/* For Facebook */}
      <meta key="og:title" property="og:title" content={title} />
      <meta
        key="og:description"
        property="og:description"
        content={`整理各種${keyword.name}相關介紹文章、知識/常識蒐集，讓你能一覽所有${keyword.name}相關文章/資訊、信義居家為您注意的居家生活大小事`}
      />
      <meta
        key="og:url"
        property="og:url"
        content={`${LS_APP_DOMAIN + pathName}`}
      />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
    </Head>
  )
}

export default MetaTags
